/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilenavplace2Inputs */

const en_profilenavplace2 = /** @type {(inputs: Profilenavplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place`)
};

const de_profilenavplace2 = /** @type {(inputs: Profilenavplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Place" |
*
* @param {Profilenavplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilenavplace2 = /** @type {((inputs?: Profilenavplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilenavplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilenavplace2(inputs)
	return de_profilenavplace2(inputs)
});
export { profilenavplace2 as "profileNavPlace" }